module.exports = __webpack_public_path__ + "img/tu4.5cbac57e.png";